import { INTERFACE } from '@/utils/INTERFACE'
import http from '@/utils/http'
import {CacheRequest} from '@/utils/queue'
import moment from 'moment'
import {getSystem} from '@/utils/site'

async function TimeDiffRequest(){
	var pre=Date.now()
	var res=await http.jsonp.get(INTERFACE().now)
    var diff=res.nowSystemTime-pre-50
	return diff
}
const controller=new CacheRequest(TimeDiffRequest)
export function fetchTimeDiff(){
    return controller.get()
}

export function getZoneDiff(){
	var sys=getSystem()
	if(sys=='ept'){
		return new Date().getTimezoneOffset() * 60000 + 28800000
	}
	if(sys=='th'){
		return new Date().getTimezoneOffset() * 60000 + 25200000
	}
	return 0
}

export function formatTime(t, format) {
	if(!t)return ''
	return moment(t).add(getZoneDiff(), 'milliseconds').format(format || "YYYY-MM-DD HH:mm:ss")
}
export function formatDurarion(t, format) {
	if(!t)t=0
	if(t<0)t=0
	return moment.utc(moment.duration(t).asMilliseconds()).format(format || "HH:mm:ss")
}
export function formatDurarionAsHours(t, format) {
	if(!t)t=0
	if(t<0)t=0
	return paddingZero(Math.floor(moment.duration(t).asHours()))+':'+moment.utc(moment.duration(t).asMilliseconds()).format(format || "mm:ss")
}
export function formatDurarionDay(t) {
	if(!t)t=0
	if(t<0)t=0
	return paddingZero(Math.floor(moment.duration(t).asDays()))
}

export function paddingZero(n){
    n=(n||0)+''
    if(n.length==1){
        n='0'+n
    }
    return n
}